import type { ClassValue } from "clsx"

import { cn } from "@/lib/utils"

type MarketingSurfaceTone = "paper" | "high" | "deep"
type MarketingSurfaceEmphasis = "default" | "selected" | "quiet"
type MarketingSurfaceElevation = "none" | "overlay" | "dialog"

const TONE_CLASS: Record<MarketingSurfaceTone, string> = {
  paper: "bg-[var(--color-paper)]",
  high: "bg-[var(--color-paper-high)]",
  deep: "bg-[var(--color-paper-deep)]",
}

const EMPHASIS_CLASS: Record<MarketingSurfaceEmphasis, string> = {
  default: "border-[var(--color-rule)]",
  selected: "border-[var(--color-vermilion)]",
  quiet: "border-[var(--color-rule-strong)]",
}

export function marketingSurfaceClass({
  className,
  emphasis = "default",
  elevation = "none",
  hover = false,
  interactive = false,
  tone = "high",
}: {
  className?: ClassValue
  emphasis?: MarketingSurfaceEmphasis
  elevation?: MarketingSurfaceElevation
  hover?: boolean
  interactive?: boolean
  tone?: MarketingSurfaceTone
} = {}) {
  return cn(
    "rounded-[var(--radius-md)] border",
    TONE_CLASS[tone],
    EMPHASIS_CLASS[emphasis],
    elevation === "none" && "surface-1",
    elevation === "overlay" && "surface-2",
    elevation === "dialog" && "surface-3",
    (hover || interactive) && "surface-hover hover:border-[var(--color-vermilion)]",
    interactive &&
      "outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-vermilion)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-paper)]",
    className,
  )
}
